// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__K3Qh3","left":"StickyBox_left__3g2hB","right":"StickyBox_right__2KkQV"};